"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColDefGrouping = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var clsx_1 = tslib_1.__importDefault(require("clsx"));
var sortBy_1 = tslib_1.__importDefault(require("lodash/fp/sortBy"));
var map_1 = tslib_1.__importDefault(require("lodash/fp/map"));
var flatten_1 = tslib_1.__importDefault(require("lodash/fp/flatten"));
var find_1 = tslib_1.__importDefault(require("lodash/fp/find"));
var intersection_1 = tslib_1.__importDefault(require("lodash/fp/intersection"));
var react_highlight_words_1 = tslib_1.__importDefault(require("react-highlight-words"));
var CheckboxListItem_1 = require("../CheckboxListItem");
var Collapsible_1 = require("../../../Components/Collapsible");
exports.ColDefGrouping = function (_a) {
    var searchValue = _a.searchValue, group = _a.group, selectedColIds = _a.selectedColIds, onCheckboxSelected = _a.onCheckboxSelected, onSelectAllSelected = _a.onSelectAllSelected, _b = _a.hideSelectAll, hideSelectAll = _b === void 0 ? false : _b;
    var isSearching = searchValue.length > 1;
    var filterColumns = function (columns) {
        return columns.filter(function (col) {
            return !isSearching ||
                col.name.toLowerCase().includes(searchValue.toLowerCase());
        });
    };
    var columnsFilteredByUserSearch = flatten_1.default(map_1.default(function (col) { return filterColumns(col.columns ? col.columns : [col]); }, group.columns));
    var getSelectAllCheckboxState = function (columnIds) {
        var checked = columnIds.every(function (id) { return selectedColIds.has(id); });
        var indeterminate = columnIds.some(function (id) { return selectedColIds.has(id); });
        return {
            indeterminate: indeterminate && !checked,
            checked: checked,
        };
    };
    var determineNextAllCheckboxState = function (indeterminate, checked) {
        var allEnabled = true;
        var allDisabled = false;
        if (indeterminate || !checked) {
            return allEnabled;
        }
        return allDisabled;
    };
    var groupColumnIds = columnsFilteredByUserSearch.map(function (col) { return col.id; });
    var _c = getSelectAllCheckboxState(groupColumnIds), indeterminate = _c.indeterminate, checked = _c.checked;
    var renderListItem = function (col, className) {
        if (find_1.default(col, columnsFilteredByUserSearch)) {
            var label = function () { return (React.createElement(React.Fragment, null, isSearching ? (React.createElement(react_highlight_words_1.default, { autoEscape: true, searchWords: [searchValue], textToHighlight: col.name, highlightClassName: "option_highlighted_text" })) : (col.name))); };
            return (React.createElement(CheckboxListItem_1.CheckboxListItem, { key: col.id, testId: "list-item-checkbox-" + col.id, checked: selectedColIds.has(col.id), onChange: function () { return onCheckboxSelected(col.id); }, className: clsx_1.default('left-aligned', className), label: label() }));
        }
        return null;
    };
    return (React.createElement(StyledDiv, { "data-testid": "col-def-grouping-" + group.name },
        columnsFilteredByUserSearch.length > 1 && !hideSelectAll ? (React.createElement(CheckboxListItem_1.CheckboxListItem, { indeterminate: indeterminate, label: "Select All", testId: "group-select-all", checked: checked, className: "left-aligned", onChange: function () {
                return onSelectAllSelected(groupColumnIds, determineNextAllCheckboxState(indeterminate, checked));
            } })) : null,
        map_1.default(function (col) {
            if (col.columns) {
                var isVisible = intersection_1.default(col.columns, columnsFilteredByUserSearch).length > 0;
                var count = intersection_1.default(map_1.default(function (_a) {
                    var id = _a.id;
                    return id;
                }, col.columns), Array.from(selectedColIds)).length;
                return (isVisible && (React.createElement(Collapsible_1.Collapsible, { label: col.name, expandMoreIcon: React.createElement("i", { className: "icon--chevron_right" }), expandLessIcon: React.createElement("i", { className: "icon--chevron_down" }), isOpen: isSearching, count: count, showZero: true, key: col.id },
                    React.createElement(StyledUl, null, map_1.default(function (column) { return renderListItem(column, 'indented'); }, sortBy_1.default(function (column) { return column.name.toLowerCase(); }, col.columns))))));
            }
            return renderListItem(col);
        }, sortBy_1.default(function (col) { return !col.columns && col.name.toLowerCase(); }, group.columns))));
};
var StyledDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  .iconContainer {\n    margin-right: 0.4rem;\n  }\n  .collapsible-container {\n    padding: 0;\n    margin: 0.2rem 0;\n  }\n  .collapsible-list-item {\n    padding: 0 1.4rem;\n  }\n  .collapsible-label {\n    font-family: ", ";\n  }\n  .collapsible-count {\n    background-color: ", ";\n  }\n  .indented {\n    label {\n      padding: 0 4.8rem;\n    }\n  }\n"], ["\n  .iconContainer {\n    margin-right: 0.4rem;\n  }\n  .collapsible-container {\n    padding: 0;\n    margin: 0.2rem 0;\n  }\n  .collapsible-list-item {\n    padding: 0 1.4rem;\n  }\n  .collapsible-label {\n    font-family: ", ";\n  }\n  .collapsible-count {\n    background-color: ", ";\n  }\n  .indented {\n    label {\n      padding: 0 4.8rem;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoRegular;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[100];
});
var StyledUl = styled_components_1.default.ul(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  padding: 0;\n  margin: 0;\n"], ["\n  padding: 0;\n  margin: 0;\n"])));
var templateObject_1, templateObject_2;
